import { Component } from '@angular/core';
import { SpControlBaseDirective } from '@shared/directives/sp-control-base/sp-control-base.directive';

@Component({
  selector: 'sp-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['../input/style.scss', './text-input.component.scss'],
})
export class TextInputComponent extends SpControlBaseDirective {
  updateValidation() {
    this.errorMessage = this.ngControl.dirty
      ? Object.entries(this.ngControl.errors ?? {})
          .map(([validation, param]) => {
            switch (validation) {
              case 'required':
                return `${this.inputLabel} cannot be empty`;
              case 'maxlength':
                return `${this.inputLabel} cannot be more than ${param.requiredLength} characters`;
              case 'minlength':
                return `${this.inputLabel} cannot be less than ${param.requiredLength} characters`;
              case 'email':
                return `must be valid email`;
              case 'mask':
                return `incorrect format`;
              default:
                return param;
            }
          })
          .shift()
      : '';
  }
}
